 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		100: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~pages-adminMarketingBanner~pages-classes~pages-classes-class-collections~pages-home~pages-lo~aed8ca04","1":"dllVendors","2":"vendors~pages-adminMarketingBanner~pages-classes~pages-classes-class-collections~pages-embed-video~p~e0aa65cb","3":"vendors~pages-adminMarketingBanner~pages-classes~pages-classes-class-collections~pages-home~pages-lo~07757df3","4":"tinymce","5":"vendors~pages-adminMarketingBanner~pages-classes~pages-classes-class-collections~pages-search~pages-site","6":"d3","7":"vendors~pages-loggedOutClasses~pages-projects-show~pages-site-gallery~pages-workshops-show","8":"pages-groups~pages-userProfile-discussionShow~pages-userProfile-discussions","9":"pages-embed-video~pages-site-join","10":"pages-site-settings-payment~pages-teams-checkout","11":"vendors~pages-customLists-lists~pages-workshops-show","12":"pages-adminMarketingBanner","13":"pages-amas","14":"pages-classes","15":"pages-customLists","16":"pages-error","17":"pages-groups","18":"pages-home","19":"pages-loggedOutClasses","20":"pages-marketingPages","21":"pages-membership","22":"pages-newClasses","23":"pages-notifications","24":"pages-projects","25":"pages-redeem","26":"pages-search","27":"pages-site","28":"pages-teach","29":"pages-teacherStats","30":"pages-teaching","31":"pages-teams","32":"pages-tutorials","33":"pages-userProfile","34":"pages-workshops","35":"pages-yourClasses","36":"pages-admin-adjust-team-seats","37":"pages-admin-batch-delete-users","38":"pages-admin-coupons","39":"pages-admin-group-requests-show","40":"pages-admin-monthly-revenue","41":"pages-admin-teacher-payout","42":"pages-admin-teams","43":"pages-admin-trust-and-safety","44":"pages-admin-users-show","45":"pages-adminMarketingBanner-edit","46":"pages-amas-form","47":"pages-checkout-item","48":"pages-classes-class-collections","49":"pages-classes-create","50":"pages-classes-video-lessons-table","51":"pages-customLists-form","52":"pages-customLists-lists","53":"pages-customLists-show","54":"pages-embed-project","55":"pages-embed-video","56":"pages-giftCards-form","57":"pages-launch-common","58":"pages-membership-cancel","59":"pages-membership-cancel-step-two","60":"pages-membership-paypal-cancel","61":"pages-membership-paypal-success","62":"pages-membership-perks","63":"pages-membership-react-checkout","64":"pages-membership-welcome","65":"pages-newClasses-class-admin","66":"pages-projects-edit","67":"pages-projects-show","68":"pages-reviews-create","69":"pages-site-gallery","70":"pages-site-join","71":"pages-site-login","72":"pages-site-premium-landing","73":"pages-site-scholarships","74":"pages-site-settings-account","75":"pages-site-settings-notifications","76":"pages-site-settings-payment","77":"pages-site-settings-react-account","78":"pages-site-settings-referrals","79":"pages-site-settings-teacher-referrals","80":"pages-site-settings-team-administration","81":"pages-site-signup","82":"pages-teach-form","83":"pages-teach-handbook","84":"pages-teams-activate","85":"pages-teams-checkout","86":"pages-teams-contact","87":"pages-teams-new","88":"pages-teams-signup","89":"pages-tutorials-form","90":"pages-tutorials-show","91":"pages-userProfile-discussionShow","92":"pages-userProfile-discussions","93":"pages-workshops-form","94":"pages-workshops-my-workshops","95":"pages-workshops-show","96":"pages-workshops-test-index","97":"vendors~pages-classes-create","98":"vendors~pages-membership-react-checkout","99":"vendors~pages-projects-edit"}[chunkId]||chunkId) + ".build." + {"0":"af5150f41e96118f39f6","1":"29c94a701ee281c9d5f3","2":"4556a230c5a8a433357b","3":"e3c524a2295fe957de0a","4":"20496c8428d3a9c8ebce","5":"38ea8a5523e9efa9a6e0","6":"8c91e4c314e38f00dbac","7":"c28f4fd0eb4d05af2015","8":"8e5637b8f18fcfb005e7","9":"9a6cd4d79bdada1241ef","10":"64dfa2fdf1c07082cf2c","11":"75170ab2292baaa888d6","12":"bf625e7a80e94b3d2068","13":"7523350e2b8e6f7267f5","14":"61fc1882c5d8b45ad99b","15":"c6f1474811f36b8d3d09","16":"f24723386b029980e25d","17":"db75faa3772bef2555f7","18":"ee89699d4de3bbeecab4","19":"c47993322a8e1c89919b","20":"25ebfd6978314d3b41e2","21":"792ccda9c8fdfaf69ec2","22":"896a3807e04896ad6f5b","23":"6c256fb4ce37083406f1","24":"464e62558748c0dd8358","25":"34f0562b1f07dcf7c64b","26":"297798c824c68c3c4121","27":"3f1714efd01d04eaa961","28":"3cffbac4728aa8ae5cda","29":"f7b71385614d62edf28b","30":"4d6c8bf4b3604415215a","31":"fc8b31ad5daf779929d3","32":"fedcc03033e669bb57f8","33":"fb9c0672e2d11a967c66","34":"c140cb186cde981e2d30","35":"2eb6a1a81f78d6778023","36":"e6097a3bd6970e9e90a0","37":"dc79219c43e0eab298b9","38":"1ef2945e733f627b4da2","39":"4b0cd32c3fb00345d446","40":"7d7bb0bd44fefa3030e4","41":"1c9370abded881194581","42":"f613bfee722eb6ffded9","43":"86ba929ab915de766377","44":"be47cac780d0d9813713","45":"12bdd52ae4afb571f9a7","46":"70422b5ec3fc2733446b","47":"dea6a67c8d8d0df8c990","48":"9d4fcafe0e11064ee50c","49":"37e1cd544621639000ca","50":"a74c3e3a194fcfed9a84","51":"cf5ca36bca14b73f399e","52":"d796d89fa0603a769fd5","53":"a1662f63f285f2fc8b3e","54":"d25920405fa9147bb00b","55":"8cecb7993cec4217a5c9","56":"170ba1134fe87aefcadb","57":"a00fdc57f5a510d077af","58":"e7741bcb7924e449a897","59":"c41bb881826c4d9e9f31","60":"0219ea04e428757611d0","61":"520d2397b401ee7c02c7","62":"a2a131ea09cccab86322","63":"21c8e065bb52b59cccdf","64":"8512fd02d97e36b6339b","65":"13cbc3e0cbd83dbff9da","66":"f3a1209b236266babe51","67":"8c20e726d232e0cea59a","68":"94dd4714a9e3beddc8cd","69":"c89966f8c645186831ca","70":"f009f096593545866f9f","71":"60142d9aad309ca045ea","72":"ce530131f775029851a5","73":"8428660c82ee1f9a5f45","74":"5c355f18fa69e69f2b9c","75":"baa0364a0e2f2968994f","76":"55236ba3fc1882dfd688","77":"8c8a7512858789777c38","78":"f2c3877e0da979a634bc","79":"eb9c07c6d26aedbbc22d","80":"c1a31df5b84c55906a62","81":"e2ce958736a006efbe7c","82":"96624f9a43b095e8de36","83":"01989b56686411234ab4","84":"b8ec047150f6146737aa","85":"4cd391a68d3369d567ea","86":"b329f10b099c69ee8012","87":"d616b80db0ef99663774","88":"7bea88f132d8b165e25a","89":"09ac5c7d9ec640ce56a5","90":"7e951acc02d004125c2b","91":"fbc478df879cb4102698","92":"6dad2c5737b05e0ddfab","93":"02d56d98a76097be15e1","94":"f7aa141e604945edc549","95":"cc1abdde0756fe487fd5","96":"80f9f003618637182f31","97":"3faed749d9cb8abe5319","98":"719c9f214411bcb9bc67","99":"f3625bd5e8b6dcdcdd2c","101":"090b529c05cc5bb7f96d","102":"5d162800f3e2407cee14"}[chunkId] + ".min.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static.skillshare.com/build/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 709);
